// Tremor Raw Select [v0.0.0]
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import * as SelectPrimitives from "@radix-ui/react-select";
import { cx, focusInput, hasErrorInput } from "../../lib/utils";
import { ChevronDownIcon, ChevronUpIcon, ChevronUpDownIcon, CheckIcon, } from "@heroicons/react/20/solid";
const Select = SelectPrimitives.Root;
Select.displayName = "Select";
const SelectGroup = SelectPrimitives.Group;
SelectGroup.displayName = "SelectGroup";
const SelectValue = SelectPrimitives.Value;
SelectValue.displayName = "SelectValue";
const selectTriggerStyles = [
    cx(
    // base
    "onvo-group/trigger onvo-flex onvo-w-full onvo-select-none onvo-items-center onvo-justify-between onvo-truncate onvo-rounded-md onvo-border onvo-px-2 onvo-py-1.5 onvo-shadow-sm onvo-outline-none onvo-transition sm:onvo-text-sm", 
    // border color
    "onvo-border-slate-200 dark:onvo-border-slate-800", 
    // text color
    "onvo-text-slate-900 dark:onvo-text-slate-50", 
    // placeholder
    "data-[placeholder]:onvo-text-slate-400 data-[placeholder]:dark:onvo-text-slate-500", 
    // background color
    "bg-white dark:bg-slate-950", 
    // hover
    "hover:onvo-bg-slate-50 hover:dark:onvo-bg-slate-950/50", 
    // disabled
    "data-[disabled]:onvo-bg-slate-100 data-[disabled]:onvo-text-slate-400", "data-[disabled]:dark:onvo-border-slate-700 data-[disabled]:dark:onvo-bg-slate-800 data-[disabled]:dark:onvo-text-slate-500", focusInput
    // invalid (optional)
    // "aria-[invalid=true]:dark:ring-red-400/20 aria-[invalid=true]:ring-2 aria-[invalid=true]:ring-red-200 aria-[invalid=true]:border-red-500 invalid:ring-2 invalid:ring-red-200 invalid:border-red-500"
    ),
];
const SelectTrigger = React.forwardRef((_a, forwardedRef) => {
    var { className, hasError, children } = _a, props = __rest(_a, ["className", "hasError", "children"]);
    return (React.createElement(SelectPrimitives.Trigger, Object.assign({ ref: forwardedRef, className: cx(selectTriggerStyles, hasError ? hasErrorInput : "", className) }, props),
        React.createElement("span", { className: "onvo-truncate" }, children),
        React.createElement(SelectPrimitives.Icon, { asChild: true },
            React.createElement(ChevronUpDownIcon, { className: cx(
                // base
                "onvo-size-4 onvo-shrink-0", 
                // text color
                "onvo-text-slate-400 dark:onvo-text-slate-600", 
                // disabled
                "group-data-[disabled]/trigger:onvo-text-slate-300 group-data-[disabled]/trigger:dark:onvo-text-slate-600") }))));
});
SelectTrigger.displayName = "SelectTrigger";
const SelectScrollUpButton = React.forwardRef((_a, forwardedRef) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement(SelectPrimitives.ScrollUpButton, Object.assign({ ref: forwardedRef, className: cx("onvo-flex onvo-cursor-default onvo-items-center onvo-justify-center onvo-py-1", className) }, props),
        React.createElement(ChevronUpIcon, { className: "onvo-size-3 onvo-shrink-0", "aria-hidden": "true" })));
});
SelectScrollUpButton.displayName = SelectPrimitives.ScrollUpButton.displayName;
const SelectScrollDownButton = React.forwardRef((_a, forwardedRef) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement(SelectPrimitives.ScrollDownButton, Object.assign({ ref: forwardedRef, className: cx("onvo-flex onvo-cursor-default onvo-items-center onvo-justify-center onvo-py-1", className) }, props),
        React.createElement(ChevronDownIcon, { className: "onvo-size-3 onvo-shrink-0", "aria-hidden": "true" })));
});
SelectScrollDownButton.displayName =
    SelectPrimitives.ScrollDownButton.displayName;
const SelectContent = React.forwardRef((_a, forwardedRef) => {
    var { className, position = "popper", children, sideOffset = 8, collisionPadding = 10 } = _a, props = __rest(_a, ["className", "position", "children", "sideOffset", "collisionPadding"]);
    return (React.createElement(SelectPrimitives.Portal, null,
        React.createElement(SelectPrimitives.Content, Object.assign({ ref: forwardedRef, className: cx(
            // base
            "onvo-relative onvo-z-50 onvo-overflow-hidden onvo-rounded-md onvo-border-solid onvo-border onvo-shadow-xl onvo-shadow-black/[2.5%]", 
            // widths
            "onvo-min-w-[calc(var(--radix-select-trigger-width)-2px)] onvo-max-w-[95vw]", 
            // heights
            "onvo-max-h-[--radix-select-content-available-height]", 
            // background color
            "onvo-bg-white dark:onvo-bg-slate-950", 
            // text color
            "onvo-text-slate-900 dark:onvo-text-slate-50", 
            // border color
            "onvo-border-slate-300 dark:onvo-border-slate-800", 
            // transition
            "onvo-will-change-[transform,opacity]", 
            // "data-[state=open]:animate-slideDownAndFade",
            "data-[state=closed]:onvo-animate-hide", "data-[side=bottom]:onvo-animate-slideDownAndFade data-[side=left]:onvo-animate-slideLeftAndFade data-[side=right]:onvo-animate-slideRightAndFade data-[side=top]:onvo-animate-slideUpAndFade", className), sideOffset: sideOffset, position: position, collisionPadding: collisionPadding }, props),
            React.createElement(SelectScrollUpButton, null),
            React.createElement(SelectPrimitives.Viewport, { className: cx("onvo-p-1", position === "popper" &&
                    "onvo-h-[var(--radix-select-trigger-height)] onvo-w-full onvo-min-w-[calc(var(--radix-select-trigger-width))]") }, children),
            React.createElement(SelectScrollDownButton, null))));
});
SelectContent.displayName = "SelectContent";
const SelectGroupLabel = React.forwardRef((_a, forwardedRef) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement(SelectPrimitives.Label, Object.assign({ ref: forwardedRef, className: cx(
        // base
        "onvo-px-3 onvo-py-2 onvo-text-xs onvo-font-medium onvo-tracking-wide", 
        // text color
        "onvo-text-slate-500 dark:onvo-text-slate-500", className) }, props)));
});
SelectGroupLabel.displayName = "SelectGroupLabel";
const SelectItem = React.forwardRef((_a, forwardedRef) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (React.createElement(SelectPrimitives.Item, Object.assign({ ref: forwardedRef, className: cx(
        // base
        "onvo-grid onvo-cursor-pointer onvo-grid-cols-[1fr_20px] onvo-gap-x-2 onvo-rounded onvo-px-3 onvo-py-2 onvo-outline-none onvo-transition-colors data-[state=checked]:onvo-font-semibold sm:onvo-text-sm", 
        // text color
        "onvo-text-slate-900 dark:onvo-text-slate-50", 
        // disabled
        "data-[disabled]:onvo-pointer-events-none data-[disabled]:onvo-text-slate-400 data-[disabled]:hover:onvo-bg-none dark:data-[disabled]:onvo-text-slate-600", 
        // focus
        "focus-visible:onvo-bg-slate-100 focus-visible:dark:onvo-bg-slate-900", 
        // hover
        "hover:onvo-bg-slate-100 hover:dark:onvo-bg-slate-900", className) }, props),
        React.createElement(SelectPrimitives.ItemText, { className: "onvo-flex-1 onvo-truncate" }, children),
        React.createElement(SelectPrimitives.ItemIndicator, null,
            React.createElement(CheckIcon, { className: "onvo-size-5 onvo-shrink-0 onvo-text-slate-800 dark:onvo-text-slate-200", "aria-hidden": "true" }))));
});
SelectItem.displayName = "SelectItem";
const SelectSeparator = React.forwardRef((_a, forwardedRef) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement(SelectPrimitives.Separator, Object.assign({ ref: forwardedRef, className: cx(
        // base
        "-onvo-mx-1 onvo-my-1 onvo-h-px", 
        // background color
        "onvo-bg-slate-300 dark:onvo-bg-slate-700", className) }, props)));
});
SelectSeparator.displayName = "SelectSeparator";
export { Select, SelectContent, SelectGroup, SelectGroupLabel, SelectItem, SelectSeparator, SelectTrigger, SelectValue, };
//# sourceMappingURL=Select.js.map